import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import AsyncSelect from "react-select";
import useAPI from "../../../hooks/useAPI";
import useToast from "../../../hooks/useToast";
import BackBtn from "../../../components/UI/BackBtn";
import Required from "../../../components/Required";
import moment from "moment";

export default function IndexCard() {
  const api = useAPI();
  const history = useHistory();
  const addToast = useToast();
  const [types, setTypes] = useState([]);
  const [units, setUnits] = useState([]);
  const [index, setIndex] = useState({});
  const { id } = useParams();

  useEffect(async () => {
    const result = await api.get("/mng/proj/types");
    const units = await api.get("/mng/units");
    setUnits(units.map((e) => ({ label: e, value: e })));
    setTypes(
      result.map((e) => {
        e.label = e.name;
        e.value = e.id;
        return e;
      })
    );
    if (id == 0) return;
    try {
      const result = await api.get(`/mng/fixedPcs/${id}`);
      result.projTypes = result.projTypes.map((e) => {
        e.label = e.name;
        e.value = e.id;
        return e;
      });
      setIndex(result);
    } catch (error) {
      console.log(error);
    }
  }, []);

  function handleChange(value, key) {
    setIndex((prev) => ({ ...prev, [key]: value }));
  }

  async function saveIndex() {
    if (!(moment(index.startDate) <= moment(index.endDate)) && index.startDate && index.endDate) {
      addToast.error("Некорректные даты");
      return;
    }
    if (!index.calcDescr) {
      addToast.error("Заполните методику расчета показателя");
      return;
    }
    try {
      const result = await api.post(`/mng/fixedPcs/${id}`, index);
      if (result.id) {
        addToast.success("Сохранено");
        handleChange(result.id, "id");
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <section className="page project-page" style={{ background: "#F5F5FF" }}>
      <div className="container">
        <div style={{ marginBottom: 16 }}>
          <BackBtn />
        </div>
        <Card className="mt-4 mb-4">
          <Card.Header className="p-4" style={{ backgroundColor: cardHeaderColor }}>
            Унифицированный показатель
          </Card.Header>
          <Card.Body className="p-4">
            <Form.Group as={Col} className="mb-4">
              <Form.Label style={styledLabel}>
                Наименование показателя <Required />
              </Form.Label>
              <Form.Control
                value={index.name}
                onChange={(e) => handleChange(e.target.value, "name")}
                placeholder="Измеримые критерии, которые должны быть удовлетворены, для того чтобы проект мог считаться успешным.Показатели могут быть как количественные (например, «Количество вновь созданных совместных программ с ведущими вузами, реализация которых началась в текущем году») так и качественные (например, «Проведен анализ ключевых территорий и представлены рекомендации по продвижению»)."
                required
                as="textarea"
                rows={3}
              />
            </Form.Group>
            <Form.Group as={Col} className="mb-4">
              <Form.Label style={styledLabel}>
                Методика расчета показателя <Required />
              </Form.Label>
              <Form.Control
                value={index.calcDescr}
                onChange={(e) => handleChange(e.target.value, "calcDescr")}
                required
                as="textarea"
                rows={2}
              />
            </Form.Group>
            <Row className="mb-4">
              <Form.Group as={Col} md="3">
                <Form.Label style={styledLabel}>
                  Единицы измерения
                  <Required />
                </Form.Label>
                <AsyncSelect
                  value={{ value: index.unit, label: index.unit }}
                  options={units}
                  onChange={(e) => handleChange(e.value, "unit")}
                  placeholder=""
                  noOptionsMessage={() => "Ничего не найдено"}
                  classNamePrefix=" selector_input_base"
                />
              </Form.Group>
              <Form.Group as={Col} md="9">
                <Form.Label style={styledLabel}>Тип проекта </Form.Label>
                <AsyncSelect
                  isMulti
                  value={index.projTypes}
                  options={types}
                  onChange={(e) => handleChange(e, "projTypes")}
                  classNamePrefix=" selector_input_base"
                  placeholder=""
                  noOptionsMessage={() => "Ничего не найдено"}
                />
              </Form.Group>
            </Row>
            <Row className="mb-4">
              <Form.Group as={Col} md="3">
                <Form.Label style={styledLabel}>
                  Дата начала <Required />
                </Form.Label>
                <Form.Control
                  value={index.startDate?.split("T")[0]}
                  onChange={(e) => handleChange(e.target.value, "startDate")}
                  type="date"
                />
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label style={styledLabel}>Дата окончания </Form.Label>
                <Form.Control
                  value={index.endDate?.split("T")[0]}
                  onChange={(e) => handleChange(e.target.value, "endDate")}
                  type="date"
                />
              </Form.Group>
            </Row>
            {/* <Row className="mb-4">
              <Form.Group as={Col} md="3">
                <Form.Label style={styledLabel}>
                  Обязательный <Required />
                </Form.Label>
                <div key="inline-radio">
                  <Form.Check
                    checked={index.required}
                    onChange={() => handleChange(true, "required")}
                    inline
                    label="Да"
                    name="group1"
                    type="radio"
                    id="inline-radio-1"
                  />
                  <Form.Check
                    checked={!index.required}
                    onChange={() => handleChange(false, "required")}
                    inline
                    label="Нет"
                    name="group1"
                    type="radio"
                    id="inline-radio-2"
                  />
                </div>
              </Form.Group>
            </Row> */}
          </Card.Body>
        </Card>
        <Card className="p-4">
          <Form.Group as={Col}>
            <Button onClick={() => history.goBack()} variant="outline-secondary">
              Отменить
            </Button>{" "}
            <Button onClick={saveIndex} variant="primary">
              Сохранить
            </Button>{" "}
          </Form.Group>
        </Card>
      </div>
    </section>
  );
}

const cardHeaderColor = "#F7F7F7";
const styledLabel = { color: "#7F7F7F", fontWeight: "600" };
